/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Timeline_HiddenInputs */



/**
* | output |
* | --- |
* | "{count} shorter steps not shown" |
*
* @param {Chat_Timeline_HiddenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_timeline_hidden = /** @type {((inputs: Chat_Timeline_HiddenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Timeline_HiddenInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} kürzere Schritte ausgeblendet`)
	return /** @type {LocalizedString} */ (`${i?.count} shorter steps not shown`)
});